import { AxiosError } from 'axios';
import { GET_GROUP_EXAM_REGISTRATION_VERIFICATION_SLIP_PDF_URL } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';
import { GET_GROUP_EXAM_REGISTRATION_VERIFICATION_SLIP_QUERY_KEY } from '../../constants/queryKeys';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface DownloadVerificationSlipResponse {
  uuid: string;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (data: DownloadVerificationSlipResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  uuid: string;
}

export const useGetDownloadVerificationSlip = ({ uuid, onSuccess, onError }: Input) => {
  const getDownloadVerificationSlip = async () => {
    const res = await axiosClient.get<DownloadVerificationSlipResponse>(
      GET_GROUP_EXAM_REGISTRATION_VERIFICATION_SLIP_PDF_URL(uuid)
    );
    return res.data;
  };
  return useCustomQuery(
    [GET_GROUP_EXAM_REGISTRATION_VERIFICATION_SLIP_QUERY_KEY],
    getDownloadVerificationSlip,
    {
      onSuccess,
      onError,
      enabled: false,
    }
  );
};
